import { OPTIONS_LANGUAGE_STORAGE_KEY } from '../../lib/optionsTranslations';

const PT_LANGUAGES = new Set(['pt', 'pt-br']);

export const getOptionsLanguageCode = () => {
  if (typeof window === 'undefined') return 'en';
  try {
    const persisted = String(window.localStorage.getItem(OPTIONS_LANGUAGE_STORAGE_KEY) || '').toLowerCase().trim();
    if (PT_LANGUAGES.has(persisted)) return 'pt';
  } catch (error) {
    return 'en';
  }
  return 'en';
};

export const getOptionsNumberLocale = () => (getOptionsLanguageCode() === 'pt' ? 'pt-BR' : 'en-US');

export const formatLocalizedNumber = (value, { minimumFractionDigits = 0, maximumFractionDigits = 2 } = {}) => {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat(getOptionsNumberLocale(), {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(Number(value));
};

export const resolveAdaptiveFractionDigits = (value, requestedDigits) => {
  const numeric = Math.abs(Number(value || 0));
  if (!Number.isFinite(numeric)) return requestedDigits;
  if (numeric >= 1) return requestedDigits;
  if (numeric >= 0.01) return Math.max(requestedDigits, 4);
  if (numeric >= 0.0001) return Math.max(requestedDigits, 6);
  return Math.max(requestedDigits, 8);
};

export const formatLocalizedUsd = (value, maximumFractionDigits = 2) => {
  if (value === null || value === undefined) return '—';
  const locale = getOptionsNumberLocale();
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: maximumFractionDigits === 0 ? 0 : 2,
    maximumFractionDigits,
  });

  if (locale !== 'pt-BR') {
    return formatter.format(Number(value));
  }

  return formatter
    .formatToParts(Number(value))
    .map((part) => (part.type === 'currency' ? 'U$' : part.value))
    .join('');
};

export const formatLocalizedNative = (value, currency, digits = 4) => {
  if (value === null || value === undefined) return '—';
  const maximumFractionDigits = resolveAdaptiveFractionDigits(value, digits);
  return `${formatLocalizedNumber(value, { minimumFractionDigits: 0, maximumFractionDigits })} ${currency}`;
};

export const formatLocalizedPercent = (percentValue, digits = 2) => {
  if (percentValue === null || percentValue === undefined) return '—';
  return `${formatLocalizedNumber(percentValue, { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`;
};

export const formatLocalizedDate = (value, options) => {
  if (!value) return '—';
  return new Intl.DateTimeFormat(getOptionsNumberLocale(), options).format(new Date(value));
};

export const formatLocalizedDateFromTimestamp = (value, options) => {
  if (value === null || value === undefined) return '—';
  return new Intl.DateTimeFormat(getOptionsNumberLocale(), options).format(new Date(value));
};
